import React from 'react';
import {Layout, AppBar} from 'react-admin';
import Menu from '../components/Menu/Menu';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core';
import Version from './utils/Version';
const MyLayout = (props) => <Layout {...props} menu={Menu} appBar={MyAppBar}/>;

export default MyLayout;
const useStyles = makeStyles({
    title: {
        flex: 1,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    spacer: {
        flex: 1,
    },
    version:{}
});
const MyAppBar = props => {
    const classes = useStyles();
    return (
        <AppBar {...props}>
            <Typography
                variant="h6"
                color="inherit"
                id="react-admin-title"
                className={classes.title}
            />
             <span className={classes.spacer} />           
            <Typography
                variant="caption"
                color="inherit"
                id="react-admin-title"
                className={classes.version}
            >
                <Version/>
            </Typography>
             
        </AppBar>
    );
};
